<a (click)="onGoogleLoginClick()" class="db-button_google {{color ? color :'ds-btn-outline-gray'}} {{size ? size : 'ds-btn-xl'}}"
        [ngClass]="{'ds-btn-disabled': loading}">
  <div *ngIf="!loading">
    <img src="assets/images/logos/google.png" alt="" class="db-icon-google-logo"/>
    <span>{{'text_continueWithGoogle' | dbText}}</span>
  </div>
  <db-loading-circular-spinner [color]="'gray'" *ngIf="loading"></db-loading-circular-spinner>
</a>
